export default function Footer() {
  const scrollTo = (id: string) => {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer style={{ backgroundColor: "#0B4D6F" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          <div>
            <img src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/1e89a5bd7d914e799e14a1aa4f84e2d1.png" alt="Jordanna Rates Advocacia" style={{ height: "64px", width: "auto" }} className="object-contain mb-4" />
            <p className="text-sm leading-relaxed" style={{ fontFamily: "Montserrat, sans-serif", color: "rgba(255,255,255,0.75)" }}>
              Advocacia Previdenciária Especializada. Defendendo seus direitos junto ao INSS com humanidade e dedicação desde 2010.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-widest" style={{ fontFamily: "Montserrat, sans-serif" }}>Links Rápidos</h4>
            <ul className="flex flex-col gap-2">
              {[["#sobre","Sobre"], ["#servicos","Serviços"], ["#como-funciona","Como Funciona"], ["#diferenciais","Diferenciais"], ["#contato","Contato"]].map(([href, label]) => (
                <li key={href}>
                  <a href={href} onClick={(e) => { e.preventDefault(); scrollTo(href); }}
                    className="text-sm cursor-pointer transition-colors hover:text-white"
                    style={{ fontFamily: "Montserrat, sans-serif", color: "rgba(255,255,255,0.7)" }}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-widest" style={{ fontFamily: "Montserrat, sans-serif" }}>Contato</h4>
            <ul className="flex flex-col gap-3">
              <li>
                <a href="https://wa.me/5598992018216" target="_blank" rel="noopener noreferrer nofollow" className="flex items-center gap-2 text-sm cursor-pointer hover:text-white transition-colors" style={{ fontFamily: "Montserrat, sans-serif", color: "rgba(255,255,255,0.75)" }}>
                  <i className="ri-whatsapp-line"></i> (98) 9 9201-8216
                </a>
              </li>
              <li>
                <a href="https://instagram.com/adv.jordannarates" target="_blank" rel="noopener noreferrer nofollow" className="flex items-center gap-2 text-sm cursor-pointer hover:text-white transition-colors" style={{ fontFamily: "Montserrat, sans-serif", color: "rgba(255,255,255,0.75)" }}>
                  <i className="ri-instagram-line"></i> @adv.jordannarates
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-widest" style={{ fontFamily: "Montserrat, sans-serif" }}>Redes Sociais</h4>
            <div className="flex gap-3">
              <a href="https://wa.me/5598992018216" target="_blank" rel="noopener noreferrer nofollow"
                className="w-10 h-10 rounded-full flex items-center justify-center cursor-pointer transition-all hover:opacity-80"
                style={{ backgroundColor: "rgba(255,255,255,0.15)" }}>
                <i className="ri-whatsapp-line text-white text-lg"></i>
              </a>
              <a href="https://instagram.com/adv.jordannarates" target="_blank" rel="noopener noreferrer nofollow"
                className="w-10 h-10 rounded-full flex items-center justify-center cursor-pointer transition-all hover:opacity-80"
                style={{ backgroundColor: "rgba(255,255,255,0.15)" }}>
                <i className="ri-instagram-line text-white text-lg"></i>
              </a>
            </div>
            <p className="text-xs mt-6 leading-relaxed" style={{ fontFamily: "Montserrat, sans-serif", color: "rgba(255,255,255,0.5)" }}>
              Atendimento online e presencial em todo o Brasil. Especialistas em aposentadoria INSS, LOAS BPC e benefícios previdenciários.
            </p>
          </div>
        </div>
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.15)" }} className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-center sm:text-left" style={{ fontFamily: "Montserrat, sans-serif", color: "rgba(255,255,255,0.5)" }}>
            © 2026 Jordanna Rates Advocacia Previdenciária. Todos os direitos reservados.
          </p>
          <a href="https://startdigital1.com.br" target="_blank" rel="noopener noreferrer nofollow"
            className="text-xs cursor-pointer hover:text-white transition-colors whitespace-nowrap"
            style={{ fontFamily: "Montserrat, sans-serif", color: "rgba(255,255,255,0.5)" }}>
            Desenvolvido por <strong className="text-white/70">Start Digital</strong>
          </a>
        </div>
      </div>
    </footer>
  );
}
